import React from 'react';
import { BarChart3, TrendingUp, Award, Target, Droplets, Sprout, Leaf } from 'lucide-react';
import { useStore } from '../store/useStore';

export const Analytics: React.FC = () => {
  // ... rest of the code remains the same
};